import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
  Typography,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
} from "@mui/material";
import { useFormik } from "formik";
import * as Yup from "yup";
import { useGetShopSubCategoriesQuery } from "slices/eCommerce/shopSubCat";

function AddForm({ open, onClose, initialData, onSubmit }) {
  const { data } = useGetShopSubCategoriesQuery({});

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      subcategory: initialData?.subcategory || "",
      name: initialData?.name || "",
    },
    validationSchema: Yup.object({
      name: Yup.string().required("Brand name is required"),
      subcategory: Yup.string().required("Category is required"),
    }),

    onSubmit: async (values) => {
      await onSubmit(values);
    },
  });

  const handleCancel = () => {
    formik.resetForm();
    onClose();
  };

  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle>{initialData ? "Edit" : "Add"}</DialogTitle>
      <form onSubmit={formik.handleSubmit}>
        <DialogContent dividers>
          <FormControl
            fullWidth
            margin="normal"
            required
            error={formik.touched.category && Boolean(formik.errors.category)}
          >
            <InputLabel id="category-label">Sub Category</InputLabel>
            <Select
              name="subcategory"
              labelId="category-label"
              value={formik.values.subcategory || ""}
              label="Category"
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
            >
              {data?.data?.data && data.data.data.length > 0 ? (
                data.data.data.map((item) => (
                  <MenuItem key={item._id} value={item._id}>
                    {item.name}
                  </MenuItem>
                ))
              ) : (
                <MenuItem disabled>No categories found</MenuItem>
              )}
            </Select>
            {formik.touched.subcategory && formik.errors.subcategory && (
              <Typography color="error" variant="caption">
                {formik.errors.subcategory}
              </Typography>
            )}
          </FormControl>

          <TextField
            name="name"
            label="Size"
            value={formik.values.name}
            onChange={formik.handleChange}
            error={formik.touched.name && Boolean(formik.errors.name)}
            helperText={formik.touched.name && formik.errors.name}
            fullWidth
            margin="normal"
          />
        </DialogContent>

        <DialogActions>
          <Button onClick={handleCancel} color="secondary">
            Cancel
          </Button>
          <Button type="submit" color="primary" variant="contained">
            {initialData ? "Update" : "Add"}
          </Button>
        </DialogActions>
      </form>
    </Dialog>
  );
}

export default AddForm;
